import { render, staticRenderFns } from "./ExpandArrow.vue?vue&type=template&id=3837620e&scoped=true"
import script from "./ExpandArrow.vue?vue&type=script&lang=js"
export * from "./ExpandArrow.vue?vue&type=script&lang=js"
import style0 from "./ExpandArrow.vue?vue&type=style&index=0&id=3837620e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837620e",
  null
  
)

export default component.exports